import { render, staticRenderFns } from "./GroupCreationScreen.vue?vue&type=template&id=81136920"
import script from "./GroupCreationScreen.vue?vue&type=script&lang=js"
export * from "./GroupCreationScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports